(function () {
  /**
   * Iraq governorate/area catalog — ported from mobile_app's bundled asset
   * (assets/commerce/iraq_address_catalog.json + domain/iraq_address_models.dart).
   * commerce-worker only validates a numeric governorateId (1-18); it has no
   * name catalog of its own (see ADR-174) — this is the source of the labels
   * shown to the customer.
   *
   * Source of truth stays mobile_app/assets/commerce/iraq_address_catalog.json;
   * if that ever regenerates, re-copy it to
   * prestige theam/assets/eros-iraq-address-catalog.json (no shared pipeline yet).
   */

  var LATIN_ONLY_RE = /^[A-Za-z0-9\s._\-–—/]+$/;

  function isLatinOnly(s) {
    return LATIN_ONLY_RE.test(s || '');
  }

  function nameForLocale(entry, languageCode, arKey, enKey, kuKey) {
    var ku = (entry[kuKey] || '').trim();
    if (languageCode === 'ku') {
      if (ku && !isLatinOnly(ku)) return ku;
      var ar = (entry[arKey] || '').trim();
      if (ar) return ar;
    }
    if (languageCode === 'en') return entry[enKey];
    if (languageCode === 'ku') return entry[kuKey];
    return entry[arKey];
  }

  // Matches mobile_app's lib/core/text/domain/arabic_search_normalize.dart
  // exactly: strip tashkeel, unify hamza/alif variants, ta-marbuta, alif
  // maqsura — so "بغداد" and "بَغْدَاد" (or ة/ه, أ/ا, etc.) are treated the same.
  var TASHKEEL_RE = /[ً-ْٰ]/g;
  function normalizeArabicSearch(s) {
    return String(s || '')
      .toLowerCase()
      .replace(TASHKEEL_RE, '')
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/ى/g, 'ي');
  }
  function arabicSearchContains(haystack, needle) {
    if (!needle) return true;
    return normalizeArabicSearch(haystack).indexOf(normalizeArabicSearch(needle)) !== -1;
  }

  var catalogPromise = null;

  // Resolve the catalog JSON's asset URL from the script tag that loaded this
  // file (data-catalog-url), matching the theme's convention for passing
  // Liquid-rendered URLs into vanilla JS without a bundler.
  function fetchCatalog() {
    var scriptTag = document.querySelector('script[data-eros-iraq-catalog-url]');
    var url = scriptTag ? scriptTag.getAttribute('data-eros-iraq-catalog-url') : null;
    if (!url) {
      return Promise.reject(new Error('eros-iraq-address-catalog.js: missing data-eros-iraq-catalog-url script attribute'));
    }
    return fetch(url).then(function (res) {
      if (!res.ok) throw new Error('Failed to load Iraq address catalog: ' + res.status);
      return res.json();
    });
  }

  function get() {
    if (!catalogPromise) catalogPromise = fetchCatalog();
    return catalogPromise;
  }

  function governorateById(catalog, id) {
    var q = String(id || '').trim();
    if (!q) return null;
    for (var i = 0; i < catalog.governorates.length; i++) {
      if (catalog.governorates[i].id === q) return catalog.governorates[i];
    }
    return null;
  }

  function areaById(governorate, areaId) {
    var q = String(areaId || '').trim();
    if (!q || !governorate) return null;
    for (var i = 0; i < governorate.areas.length; i++) {
      if (governorate.areas[i].id === q) return governorate.areas[i];
    }
    // ADR-183: a hidden duplicate id (ADR-180 aliasIds) is the same place —
    // an address saved before the dedupe still resolves, to the kept area.
    for (var j = 0; j < governorate.areas.length; j++) {
      var aliases = governorate.areas[j].aliasIds;
      if (aliases && aliases.indexOf(q) !== -1) return governorate.areas[j];
    }
    return null;
  }

  window.ErosIraqAddressCatalog = {
    get: get, // Promise<{version, governorates: [...]}>
    governorateById: governorateById,
    areaById: areaById,
    governorateNameForLocale: function (governorate, languageCode) {
      return nameForLocale(governorate, languageCode, 'nameAr', 'nameEn', 'nameKu');
    },
    areaLabelForLocale: function (area, languageCode) {
      return nameForLocale(area, languageCode, 'labelAr', 'labelEn', 'labelKu');
    },
    searchContains: arabicSearchContains,
  };
})();
